<template>
<div>
    <div class="selectTypeBox">
        <el-radio-group v-model="selectType" @change="onChangeSelectType">
            <el-radio-button label="待收款"></el-radio-button>
            <el-radio-button label="首付收款"></el-radio-button>
            <el-radio-button label="尾款收款"></el-radio-button>
        </el-radio-group>
    </div>
    <div style="width: 80%; margin: 15px auto 15px auto">
    </div>
    <div class="itemList">
        <div class="itemDiv" v-for="item in dataList" :key="item.id">
            <div class="leftDiv">
                <P>{{item.resumeName + ' | ' + item.positionName + ' | ' + item.entryDate}}
                    （
                    {{item.status === 1 ? '待收款' : ''}}
                    {{item.status === 2 ? '首付收款' : ''}}
                    {{item.status === 3 ? '尾款收款' : ''}}
                    {{item.status === 4 ? '首付款结算' : ''}}
                    {{item.status === 5 ? '全部结算' : ''}}
                    ）
                    （
                    {{item.settlementStatus === 1 ? '未结算' : ''}}
                    {{item.settlementStatus === 2 ? '首付款已结算' : ''}}
                    {{item.settlementStatus === 3 ? '全部结算完成' : ''}}
                    ）
                </P>
                <P>{{'月薪：' + item.monthlyPay + ' | 佣金：' + item.moneyReward}}</P>
                <P>{{'首付款：' + item.homeAmount + ' | 实际支付首付款：' + item.homePayAmount}}</P>
                <P v-if="item.homeAmountTax">{{'首付款扣税：' + item.homeAmountTax + ' | 首付款扣税后剩余：' + item.homeAmountAfterTax + ' | 首付款状态标记时间：' + item.homePayTime}}</P>
                <P>{{'尾款：' + item.warrantyAmount + ' | 实际支付尾款：' + item.warrantyPayAmount + ' | 尾款到期时间：' + item.warrantyTime}}</P>
                <P v-if="item.warrantyAmountTax">{{'尾款扣税：' + item.warrantyAmountTax + ' | 尾款扣税后剩余：' + item.warrantyAmountAfterTax + ' | 尾款状态标记时间：' + item.warrantyPayTime}}</P>
                <p>{{'付款规则：' + item.payRules + ' | '}}{{'佣金比率： ' + item.commissionRate + '% | '}}{{item.commissionMethod === 1 ? '实时结算' : '保证期过后结算'}}</p>
            </div>
            <div class="rightDiv">
                <div>
                    <el-button v-if="item.status === 1" @click='goUpdateState(item,2)'>首付收款</el-button>
                    <el-button v-if="item.status === 2 || item.status === 1" @click='goUpdateState(item,3)'>尾款收款</el-button>
                    <el-button v-if="item.commissionMethod === 2 && item.status === 3 && item.settlementStatus === 1" @click='goSettlement(item)'>全部结算</el-button>
                    <el-button v-if="item.commissionMethod === 1 && item.status === 2 && item.settlementStatus === 1" @click='goSettlement(item)'>首付款结算</el-button>
                    <el-button v-if="item.commissionMethod === 1 && item.status === 3 && item.settlementStatus === 2" @click='goSettlement(item)'>尾款结算</el-button>
                    <el-button v-if="item.commissionMethod === 1 && item.status === 3 && item.settlementStatus === 1" @click='goSettlement(item)'>全部结算</el-button>
                </div>
            </div>
        </div>
    </div>
    <el-dialog title="佣金状态更新" :visible.sync="dialogVisible" width="30%">
        <div v-if="setItem.status === 1" class="demo-input-suffix">
            <p>首付款实际支付金额（元）：</p>
            <el-input placeholder="请输入首付款实际支付金额" type="number" v-model="homePayAmount">
            </el-input>
        </div>
        <div v-if="setItem.status === 1" class="demo-input-suffix">
            <p>首付款交税金额（元）：</p>
            <el-input placeholder="请输入首付款交税金额" type="number" v-model="homeAmountTax">
            </el-input>
            <div style="padding: 10px 0;">*具体交税金额请考发票上面显示的金额</div>
        </div>
        <div v-if="setItem.status === 1" class="demo-input-suffix">
            <p>首付款税后金额（元）：</p>
            <el-input readonly type="number" v-model="homeAmountAfterTax">
            </el-input>
        </div>
        <div v-if="setItem.status === 1" class="demo-input-suffix">
            <p>首付款发票号：</p>
            <el-input placeholder="请输入首付款发票号" type="number" v-model="homeTaxNumber">
            </el-input>
        </div>
        <div v-if="setState === 3" class="demo-input-suffix">
            <p>尾款实际支付金额（元）：</p>
            <el-input placeholder="请输入尾款实际支付金额" type="number" v-model="warrantyPayAmount">
            </el-input>
        </div>
        <div v-if="setState === 3" class="demo-input-suffix">
            <p>尾款交税金额（元）：</p>
            <el-input placeholder="请输入尾款交税金额" type="number" v-model="warrantyAmountTax">
            </el-input>
            <div style="padding: 10px 0;">*具体交税金额请考发票上面显示的金额</div>
        </div>
        <div v-if="setState === 3" class="demo-input-suffix">
            <p>尾款税后金额（元）：</p>
            <el-input readonly type="number" v-model="warrantyAmountAfterTax">
            </el-input>
        </div>
        <div v-if="setState === 3" class="demo-input-suffix">
            <p>尾款发票号码：</p>
            <el-input placeholder="请输入尾款发票号码：" type="number" v-model="warrantyTaxNumber">
            </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false;updataItem()">确 定</el-button>
    </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible1" width="30%">
        <p>是否对该条目进行结算</p>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible1 = false;settlement()">确 定</el-button>
    </span>
    </el-dialog>
    <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal">
        </el-pagination>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'moneyReward',
    props: {},
    data() {
        return {
            positionName: '',
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            id: '',
            dialogVisible: false,
            setItem: false,
            setState: 1,
            homePayAmount: '',
            homeTaxNumber: '',
            homeAmountTax: '',
            homeAmountAfterTax: '',
            warrantyPayAmount: '',
            warrantyTaxNumber: '',
            warrantyAmountTax: '',
            warrantyAmountAfterTax: '',
            selectType: '待收款',
            selectTypeArray: {
                "待收款": 1,
                "首付收款": 2,
                "尾款收款": 3
            },
            dialogVisible1: false,
            settlementItem: false
        }
    },
    watch: {
        inputV1: function () {
            this.inputV2 = Number(this.inputV1) * 10 * 18 / 100
        },
        homePayAmount: function () {
            this.homeAmountAfterTax = this.homePayAmount - this.homeAmountTax
        },
        homeAmountTax: function () {
            this.homeAmountAfterTax = this.homePayAmount - this.homeAmountTax
        },
        warrantyPayAmount: function () {
            this.warrantyAmountAfterTax = this.warrantyPayAmount - this.warrantyAmountTax
        },
        warrantyAmountTax: function () {
            this.warrantyAmountAfterTax = this.warrantyPayAmount - this.warrantyAmountTax
        }
    },
    created: function () {
        this.id = this.$route.query.id
    },
    methods: {
        onChangeSelectType(e) {
            this.pageSize = 20,
                this.pageNumber = 1,
                this.selectType = e
            this.getPositionLost()
        },
        getPositionLost: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/candidate/moneyRewardList',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                params: {},
                data: {
                    jobId: this.id,
                    pageSize: this.pageSize,
                    pageNum: this.pageNumber,
                    status: this.selectTypeArray[this.selectType]
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    that.dataList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getPositionLost()
        },
        goUpdateState: function (item, status) {
            this.setItem = item
            this.setState = status
            this.dialogVisible = true
        },
        updataItem: function () {
            let that = this
            let data = {
                id: this.setItem.id,
                status: this.setState
            }
            if (this.setItem.status === 1) {
                data.homePayAmount = this.homePayAmount
                data.homeTaxNumber = this.homeTaxNumber
                data.homeAmountTax = this.homeAmountTax
                data.homeAmountAfterTax = this.homeAmountAfterTax
            }
            if (this.setState === 3) {
                data.warrantyPayAmount = this.warrantyPayAmount
                data.warrantyTaxNumber = this.warrantyTaxNumber
                data.warrantyAmountTax = this.warrantyAmountTax
                data.warrantyAmountAfterTax = this.warrantyAmountAfterTax
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/candidate/upateMoneyRewardStatus',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '佣金状态更新成功',
                        type: 'success'
                    });
                    that.homePayAmount = ''
                    that.homeTaxNumber = ''
                    that.homeAmountTax = ''
                    that.homeAmountAfterTax = ''
                    that.warrantyPayAmount = ''
                    that.warrantyTaxNumber = ''
                    that.warrantyAmountTax = ''
                    that.warrantyAmountAfterTax = ''
                    that.setItem = false
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        goSettlement: function (item) {
            this.settlementItem = item
            this.dialogVisible1 = true
        },
        settlement: function () {
            let that = this
            let data = {
                id: this.settlementItem.id,
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/candidate/settlementMoneyReward',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '结算成功',
                        type: 'success'
                    });
                    that.settlementItem = false
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        }
    },
    mounted: function () {
        this.getPositionLost();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.itemList {
    margin-top: 20px;
}

.itemList .itemDiv {
    background-color: #ffffff;
    width: 80%;
    margin: 0 auto 15px auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px;
    border-radius: 8px;
    min-height: 150px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.itemList .itemDiv .leftDiv {
    width: 70%;
}

.itemList .itemDiv .leftDiv p {
    font-size: 18px;
    color: #757373;
}

.itemList .itemDiv .leftDiv div {
    padding: 30px 0;
}

.itemList .itemDiv .rightDiv {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.itemList .itemDiv .rightDiv p {
    font-size: 32px;
    color: #1AAD19;
    text-align: center;
}

.itemList .itemDiv .rightDiv div {
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.block {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
}

.demo-input-suffix>p {
    padding: 10px 0;
}
</style>
